import { useEffect } from 'react';
import { SHARED_ROUTES } from '../constants/shared.routes';
import { AuthContextLoginParams } from '../models/auth';
import { MessageService } from '../utilities/message.service';

type LoginCallback = (
  loginParams: AuthContextLoginParams,
  redirectPath?: string | boolean
) => void;

export function useAuthWindow(
  onLogin: LoginCallback,
  redirectPath?: string | boolean
) {
  useEffect(() => {
    /**
     * Listen to login requests from child window (platform)
     *
     * Will only be triggered when the login is triggered from the platform
     * because the causer of this event, MessageService.requestLoginFromChild,
     * can only be triggered from the child window (platform) and only posts
     * the message to it's opener (parent window, admin)
     */

    MessageService.addRequestLoginFromChildEventListener(
      (loginParams: AuthContextLoginParams) => {
        onLogin(loginParams, redirectPath);
      }
    );
    return () => {
      MessageService.removeRequestLoginFromChildEventListener();
    };
  }, [onLogin, redirectPath]);

  return (action: 'login' | 'signup') => {
    if (typeof window === 'undefined') return;

    if (action === 'signup') {
      window.location.href = `${process.env['NEXT_PUBLIC_PLATFORM_URL']}${SHARED_ROUTES[action]}?authWindow=true`;
      return;
    }
    const platformUrl = `${process.env['NEXT_PUBLIC_PLATFORM_URL']}${SHARED_ROUTES[action]}?authWindow=true`;
    window.open(platformUrl, action);
  };
}
